module.exports = {
  title: 'Scummy Poker 🤙',
  description: `
    Take your agile/scrum backlog estimation to a whole new level. No more yelling
    out numbers or boring online card estimation. Now you can throw out your cards in 
    style, and have fun while doing it.
  `,
  url: 'https://scummypoker.com/',
  tags: ['Design', 'Express', 'JavaScript', 'Node', 'Redis', 'Socket.io'],
  images: [
    require('./images/1.png'),
    require('./images/2.png'),
    require('./images/3.png'),
    require('./images/4.png'),
    require('./images/5.png'),
    require('./images/6.png'),
  ],
};



// WEBPACK FOOTER //
// ./src/data/works/scummypoker/index.js